import { render, staticRenderFns } from "./GetDataSourceLogsDetails.vue?vue&type=template&id=0f77fbc0"
import script from "./GetDataSourceLogsDetails.vue?vue&type=script&lang=js"
export * from "./GetDataSourceLogsDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports